import { trackEvent } from "../analytics";
import { ANALYTICS } from "./analyticsEvents";
import { markSharePromptShown } from "./wedgeFunnel";

export const KITA_REMINDER_COMPLETE_KEY = "albis.kitaReminderCompleteTracked";
const KITA_REMINDER_TAP_DEDUP_KEY = "albis.lastKitaReminderTap";

function shouldSkipDuplicateTap(params) {
  const key = `${params.extraction_id}:${params.event_index}:${params.reminder_kind}`;
  try {
    const last = sessionStorage.getItem(KITA_REMINDER_TAP_DEDUP_KEY);
    if (last === key) return true;
    sessionStorage.setItem(KITA_REMINDER_TAP_DEDUP_KEY, key);
  } catch {
    /* ignore */
  }
  return false;
}

function parseReminderParams(searchParams) {
  if (!searchParams || searchParams.get("kita_reminder") !== "1") return null;
  const reminderKind = searchParams.get("reminder_kind");
  const extractionId = searchParams.get("extraction_id");
  const eventIndexRaw = searchParams.get("event_index");
  const eventIndex =
    eventIndexRaw != null && eventIndexRaw !== "" ? Number(eventIndexRaw) : null;
  return {
    reminder_kind: reminderKind || null,
    extraction_id: extractionId || null,
    event_index: Number.isFinite(eventIndex) ? eventIndex : null,
    source: "deep_link",
  };
}

/** Fire kita_reminder_complete once per browser after first reminder tap/open. */
export function maybeTrackKitaReminderComplete(context = {}) {
  try {
    if (localStorage.getItem(KITA_REMINDER_COMPLETE_KEY)) return;
    localStorage.setItem(KITA_REMINDER_COMPLETE_KEY, "1");
    markSharePromptShown({ trigger: "reminder_complete", ...context });
    trackEvent(ANALYTICS.kita_reminder_complete);
  } catch {
    markSharePromptShown({ trigger: "reminder_complete", ...context });
    trackEvent(ANALYTICS.kita_reminder_complete);
  }
}

/**
 * @param {{
 *   analytics?: { event?: string, reminder_kind?: string, extraction_id?: string, event_index?: number|null, source_type?: string } | null,
 *   searchParams?: URLSearchParams,
 *   eventCount?: number|null,
 * }} args
 */
export function trackKitaReminderTap({ analytics, searchParams, eventCount } = {}) {
  let params = null;
  let source = "push";

  if (analytics?.event === ANALYTICS.kita_reminder_tap) {
    params = {
      reminder_kind: analytics.reminder_kind || null,
      extraction_id: analytics.extraction_id || null,
      event_index: analytics.event_index ?? null,
      source: "push",
    };
  } else if (searchParams) {
    params = parseReminderParams(searchParams);
    if (params) source = params.source;
  }

  if (!params) return;
  if (shouldSkipDuplicateTap(params)) return;

  trackEvent(ANALYTICS.kita_reminder_tap, {
    reminder_kind: params.reminder_kind,
    extraction_id: params.extraction_id,
    event_index: params.event_index,
    source,
  });
  maybeTrackKitaReminderComplete(
    eventCount != null ? { eventCount } : {},
  );
}

export function trackKitaReminderPromiseShown({ extraction_count, event_count } = {}) {
  trackEvent(ANALYTICS.kita_reminder_promise_shown, {
    extraction_count,
    event_count,
  });
}
